const showHiddenStaffContact = () =>{
    if(document.querySelector('.ume-staff-contact-hidden')){
        document.addEventListener('click', ev => {
            const matches = ev.target.matches ? ev.target.matches('.ume-staff-show-contact-button') : ev.target.msMatchesSelector('.ume-staff-show-contact-button');
            if (!matches) return;
            const button = ev.target;
            const icon = button.querySelector('span');
            const targetContainer = button.nextElementSibling;
            if(targetContainer.classList.contains('d-none')){
                targetContainer.classList.remove('d-none');
                targetContainer.classList.add('d-flex');
                icon.classList.remove('icon-accordion-plus');
                icon.classList.add('icon-accordion-minus');
                return;
            }
            targetContainer.classList.remove('d-flex');
            targetContainer.classList.add('d-none');
            icon.classList.remove('icon-accordion-minus');
            icon.classList.add('icon-accordion-plus');

        })

    }
}
export default showHiddenStaffContact;